import history from '@src/routes/history';
import queryString from 'query-string';

// const pathObj = {
//     pathname: 'Home',
//     search: '?test=1',
//     query: {
//         test: '1',
//     },
// };
// props.location.state;
// const state = {
//     test: '1',
// };

export default class router {
    // 換頁，將query自動轉成search
    static push(pathObj, state) {
        if (pathObj?.query) {
            pathObj.search = queryString.stringify(pathObj.query);
        }
        const { pathname } = history.location;

        history.push(pathObj, { prevUrl: pathname, ...state });
    }

    static back() {
        const { state = {} } = history.location;
        const { prevUrl } = state;

        if (prevUrl) {
            history.goBack();
        } else {
            history.push({
                pathname: 'Home',
            });
        }
    }

    // 取得參數，預設自動帶入window.location.search
    static getQuery(search = window.location.search) {
        return queryString.parse(search);
    }

    // 設定query，不刷新網頁
    static setQuery(query) {
        const search = queryString.stringify(query);
        const path = window.location.pathname + '?' + search;

        window.history.replaceState({}, null, path);
    }

    // 取得state
    static getState() {
        const { state = {} } = history.location;

        return state;
    }

    // 取得本地網址
    static getLocaleOpenUrl({ pathname, query }) {
        return `${window.location.origin}/${pathname}?${queryString.stringify(query)}`;
    }
}
